import React from 'react';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Button,
  Card,
  CardHeader,
  CardBody,
  SimpleGrid,
  Badge,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { FaCrown, FaCoins, FaArrowRight } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Account = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const getSubscriptionColor = (type) => {
    switch (type) {
      case 'premium':
        return 'purple';
      case 'standard':
        return 'blue';
      default:
        return 'gray';
    }
  };

  return (
    <Box bg='brand.background' minH='100vh' py={8}>
      <Container maxW='container.md'>
        <VStack spacing={8} align='stretch'>
          <Heading color='brand.text'>My Account</Heading>

          <Card>
            <CardHeader>
              <Heading size='md'>Account Details</Heading>
            </CardHeader>
            <CardBody>
              <VStack align='stretch' spacing={4}>
                <HStack justify='space-between'>
                  <Text color='gray.600'>Email</Text>
                  <Text fontWeight='medium'>{user?.email}</Text>
                </HStack>
                <HStack justify='space-between'>
                  <Text color='gray.600'>Name</Text>
                  <Text fontWeight='medium'>
                    {user?.firstName} {user?.lastName}
                  </Text>
                </HStack>
              </VStack>
            </CardBody>
          </Card>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
            <Card>
              <CardHeader>
                <HStack>
                  <Icon as={FaCrown} color='brand.primary' boxSize={5} />
                  <Heading size='md'>Subscription</Heading>
                </HStack>
              </CardHeader>
              <CardBody>
                <VStack align='stretch' spacing={4}>
                  <HStack justify='space-between'>
                    <Text color='gray.600'>Current Plan</Text>
                    <Badge
                      colorScheme={getSubscriptionColor(user?.subscription)}
                      fontSize='md'
                      px={2}
                      py={1}
                      textTransform='capitalize'
                    >
                      {user?.subscription || 'None'}
                    </Badge>
                  </HStack>
                  <Button
                    rightIcon={<FaArrowRight />}
                    onClick={() => navigate('/subscription')}
                    colorScheme='blue'
                    variant='outline'
                    size='sm'
                  >
                    Change Plan
                  </Button>
                </VStack>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <HStack>
                  <Icon as={FaCoins} color='brand.primary' boxSize={5} />
                  <Heading size='md'>Credits</Heading>
                </HStack>
              </CardHeader>
              <CardBody>
                <VStack align='stretch' spacing={4}>
                  <HStack justify='space-between'>
                    <Text color='gray.600'>Available Credits</Text>
                    <Text fontSize='xl' fontWeight='bold'>
                      {user?.credits || 0}
                    </Text>
                  </HStack>
                  <Text fontSize='sm' color='gray.500'>
                    Credits are used for premium searches and detailed reports
                  </Text>
                </VStack>
              </CardBody>
            </Card>
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default Account;
